import Button from '@/common/components/base/button/Button';
import MainModal from '@/common/components/base/modal/Modal';
import { MainModalProps } from '@/common/components/base/modal/Modal.type';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import { Flex } from 'styled-system/jsx';

const VehicleTypeMissErrorModal = ({
  closeModal,
  open,
  onNavigate,
}: MainModalProps & { onNavigate: () => void }) => {
  return (
    <MainModal open={open} closeModal={closeModal}>
      <VehicleTypeMissError closeModal={closeModal} onNavigate={onNavigate} />
    </MainModal>
  );
};

const VehicleTypeMissError = ({
  closeModal,
  onNavigate,
}: {
  closeModal: MainModalProps['closeModal'];
  onNavigate: () => void;
}) => {
  return (
    <>
      <TitleDescription>نیاز به تکمیل مشخصات وسیله‌نقلیه</TitleDescription>
      <Typography textStyle="b1" mt={24} color="black-1">
        لطفا از قسمت مشخصات وسیله نقلیه، ابتدا نوع وسیله نقلیه (سواری، موتور
        سیکلت و ...) را مشخص و سپس اقدام به عکس برداری کنید.
      </Typography>
      <Flex mb="20px" mt="30px" w="100%" gap="10px">
        {' '}
        <Button
          color="common"
          variant="outlined"
          fullWidth
          mt="1rem"
          onClick={closeModal}
        >
          متوجه شدم
        </Button>
        <Button mt="1rem" onClick={onNavigate} fullWidth>
          تکمیل مشخصات
        </Button>
      </Flex>
    </>
  );
};

export default VehicleTypeMissErrorModal;
